const state = {
  items: [],
  speed: 800,
  initialized: false,
  pause: true,
  animating: false,
  active: null,
  activepanels: [],
  theme: 'light',
  navtheme: 'light',
  logotheme: null,
  previous: null,
  scrolltopanel: null,
  islastactive: false,
  isfirstactive: false,
  scrolltocomplete: false
}

export default state



// WEBPACK FOOTER //
// ./assets/js/store/modules/panels/state.js